import styled from 'styled-components';
import { MDBListGroupItem } from 'mdb-react-ui-kit';

export const PlayerHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.75rem;
    flex-wrap: wrap;
`;

export const PlayerName = styled.h5`
    margin: 0;
    font-weight: 700;
    font-size: 1.08rem;
    letter-spacing: -0.01em;
`;

export const PlayerPosition = styled.span`
    font-size: 0.78rem;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-weight: 700;
`;

export const StatLabel = styled.span`
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #94a3b8;
`;

export const StatValue = styled.span`
    font-size: 1.2rem;
    font-weight: 800;
    color: #f8fafc;
    line-height: 1;
`;

export const SectionTitle = styled.h6`
    margin: 0 0 0.75rem;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    font-weight: 800;
    color: #cbd5e1;
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;

    i {
        color: #38bdf8;
        font-size: 0.75rem;
    }
`;

export const StatsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
    gap: 0.6rem;
`;

export const StatTile = styled.div`
    background:
        radial-gradient(circle at 100% 0%, rgba(14,165,233,0.18) 0%, rgba(14,165,233,0) 45%),
        rgba(15,23,42,0.7);
    border: 1px solid rgba(148,163,184,0.2);
    border-radius: 12px;
    padding: 0.62rem 0.72rem;
    display: grid;
    gap: 0.35rem;
    min-height: 4.2rem;
`;

export const PropsList = styled.div`
    display: grid;
    gap: 0.55rem;
`;

export const PropCardButton = styled(MDBListGroupItem)`
    cursor: pointer;
    transition: border-color 0.2s ease, transform 0.2s ease, background 0.2s ease;
    display: grid;
    gap: 0.42rem;
    border: 1px solid rgba(148,163,184,0.25) !important;
    border-radius: 12px !important;
    background:
        radial-gradient(circle at 0% 0%, rgba(56,189,248,0.14) 0%, rgba(56,189,248,0) 48%),
        rgba(15,23,42,0.82) !important;
    color: #e2e8f0;
    padding: 0.62rem 0.72rem !important;

    &:hover {
        border-color: rgba(56,189,248,0.5) !important;
        background:
            radial-gradient(circle at 0% 0%, rgba(56,189,248,0.2) 0%, rgba(56,189,248,0) 54%),
            rgba(15,23,42,0.95) !important;
        transform: translateY(-1px);
    }
`;

export const PropTitleRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.55rem;
`;

export const PropNameText = styled.span`
    font-size: 0.86rem;
    font-weight: 700;
    color: #f8fafc;
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
    min-width: 0;

    i {
        color: #38bdf8;
        font-size: 0.72rem;
        flex-shrink: 0;
    }
`;

export const PropMetaRow = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.35rem;
`;

export const PropChip = styled.span`
    font-size: 0.67rem;
    font-weight: 800;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    border-radius: 999px;
    padding: 0.18rem 0.55rem;
    border: 1px solid ${({ $tone }) =>
        $tone === 'over' ? 'rgba(74,222,128,0.45)' :
        $tone === 'under' ? 'rgba(248,113,113,0.45)' :
        'rgba(56,189,248,0.45)'};
    color: ${({ $tone }) =>
        $tone === 'over' ? '#4ade80' :
        $tone === 'under' ? '#f87171' :
        '#bae6fd'};
    background: ${({ $tone }) =>
        $tone === 'over' ? 'rgba(22,163,74,0.16)' :
        $tone === 'under' ? 'rgba(220,38,38,0.16)' :
        'rgba(14,165,233,0.16)'};
`;

export const EmptyPropsState = styled.div`
    padding: 1rem;
    border: 1px dashed rgba(148,163,184,0.32);
    border-radius: 12px;
    text-align: center;
    color: #94a3b8;
    font-size: 0.82rem;
    font-style: italic;
    background: rgba(15,23,42,0.42);
`;
